import styled from "styled-components/macro";
import { FC } from "react";
import { useTranslation } from "react-i18next";

const Block = styled.div`
  background: #243044cc;
  position: absolute;
  top: 52px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`
const BlockContent = styled.div`
  position: absolute;
  top: calc(50% - 60px);

  p {
    color: #d7d7d7;
  }
`
type PropsType = {
  visible: boolean
}

const NoDataAvailable: FC<PropsType> = ({visible}) => {
  const { t } = useTranslation();
  return visible ? (
    <Block>
      <BlockContent>
        <p>{t("statsPage_noDataAvailable_topText")}</p>
        <p>{t("statsPage_noDataAvailable_bottomText")}</p>
      </BlockContent>
    </Block>
  ) : null
}

export default NoDataAvailable